import { Fragment, useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useLanguage } from "@/context/LanguageContext";
import { privacy } from "@/lib/privacy";

function Section({ number, title, children }) {
  return (
    <section className="py-8 border-b border-[#ECE8DD] last:border-b-0">
      <h2 className="font-display text-xl md:text-2xl font-semibold tracking-tight text-[#1A1814] mb-4">
        {number}. {title}
      </h2>
      <div className="space-y-3 text-[15px] leading-relaxed text-[#4A473F]">
        {children}
      </div>
    </section>
  );
}

function Block({ block }) {
  if (block.h) {
    return <p className="font-medium text-[#1A1814]">{block.h}</p>;
  }
  if (block.ul) {
    return (
      <ul className="list-disc pl-5 space-y-1">
        {block.ul.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    );
  }
  if (block.lines) {
    return (
      <p>
        {block.lines.map((line, i) => (
          <Fragment key={i}>
            {i > 0 && <br />}
            {line}
          </Fragment>
        ))}
      </p>
    );
  }
  if (block.table) {
    const { head, rows } = block.table;
    return (
      <div className="overflow-x-auto rounded-2xl border border-[#ECE8DD] mt-2">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-[#F1EEE4]">
              {head.map((cell, i) => (
                <th
                  key={i}
                  className="px-5 py-3 font-display font-semibold text-[#1A1814] border-b border-[#ECE8DD]"
                >
                  {cell}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className={i !== rows.length - 1 ? "border-b border-[#ECE8DD]" : ""}>
                {row.map((cell, j) => (
                  <td key={j} className="px-5 py-3 align-top">
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  return <p>{block.p}</p>;
}

export default function Privacy() {
  const { locale } = useLanguage();
  const content = privacy[locale];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main
      data-testid="privacy-root"
      className="min-h-screen bg-[#FAFAF7] text-[#1A1814] selection:bg-[#437DEA] selection:text-white"
    >
      <Header />

      <div className="container-iko max-w-3xl pt-16 pb-8">
        <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#94918A] mb-4">
          {content.eyebrow}
        </div>
        <h1 className="font-display text-3xl md:text-4xl font-semibold tracking-tight mb-2">
          {content.title}
        </h1>
      </div>

      <div className="container-iko max-w-3xl pb-24">
        {content.sections.map((section, i) => (
          <Section key={i} number={i + 1} title={section.title}>
            {section.blocks.map((block, j) => (
              <Block key={j} block={block} />
            ))}
          </Section>
        ))}
      </div>

      <Footer />
    </main>
  );
}
